module.exports = __webpack_public_path__ + "static/media/search-icon.4a24f5c6.svg";